import * as React from "react";
import styled from "styled-components";
import cn from "classnames";

import { Icon } from "../Icon";
import { themeValues } from "../theme";

export const StyledLearnMore = styled.a`
  color: ${themeValues.primaryColor};
  font-weight: 500;
  align-items: center;
  display: flex;
  font-size: ${themeValues.fontSize.small};
  line-height: 13px;

  &.disabled {
    color: ${themeValues.ghostColor};

    & svg path {
      stroke: ${themeValues.ghostColor};
    }
  }

  &:hover {
    text-decoration: underline;
    color: ${themeValues.primaryColor};

    .disabled {
      color: ${themeValues.ghostColor};
    }
  }

  & svg {
    margin-right: 6px;
  }
`;
StyledLearnMore.displayName = "StyledLearnMore";

interface ILearnMoreProps {
  href: string;
  title?: string;
  disabled?: boolean;
}

export function LearnMore({ href, title, disabled }: ILearnMoreProps): JSX.Element {
  return <StyledLearnMore
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={cn({
      "disabled": disabled
    })}
  >
    <Icon glyph="learnMore" />
    {title || "Learn more"}
  </StyledLearnMore>;
}